"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var plusBtn = $('.tabs-header__button');
    var descriptionSlide = function () {
        $(this).parents('.tabs-header').siblings('.tabs-description').slideToggle();
        var that = $(this).parents('.tabs-header');
        var other = $(this).parents('.all-categories-tabs-wrapper').find('.tabs-header').not(that);
        other.siblings('.tabs-description').slideUp();
        console.log(other.siblings('.tabs-description').siblings('.tabs-header').find('.plus-sign'));
        other.siblings('.tabs-description').siblings('.tabs-header').find('.plus-sign').removeClass('button-clicked');
        $(this).children().toggleClass('button-clicked');
    };
    plusBtn.on('click', descriptionSlide);
};
exports.init = init;
